/** @jsx jsx */
import { jsx } from "theme-ui"

const Logo = () => {
  // return <img src={LogoImg} />
  return (
    <svg
      width="234"
      height="47"
      viewBox="0 0 234 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.9712 10.4053C16.0312 10.4053 10.4053 16.0312 10.4053 22.9712C10.4053 29.9112 16.0312 35.5371 22.9712 35.5371C29.9112 35.5371 35.5371 29.9112 35.5371 22.9712C35.5371 16.0312 29.9112 10.4053 22.9712 10.4053ZM22.9712 12.8638C20.3487 12.8638 18.1634 17.389 18.1634 22.9712C18.1634 28.5533 20.5126 33.0786 22.9712 33.0786C28.5533 33.0786 33.0786 28.5533 33.0786 22.9712C33.0786 17.389 28.5533 12.8638 22.9712 12.8638Z"
        sx={{ fill: `primary` }}
      />
      <circle cx="7.4641" cy="22.9052" r="2.05882" sx={{ fill: `primary` }} />
      <circle cx="38.3464" cy="22.9052" r="2.05882" sx={{ fill: `primary` }} />
      <circle
        cx="22.9053"
        cy="7.46407"
        r="2.05882"
        transform="rotate(90 22.9053 7.46407)"
        sx={{ fill: `primary` }}
      />
      <circle
        cx="22.9053"
        cy="38.3464"
        r="2.05882"
        transform="rotate(90 22.9053 38.3464)"
        sx={{ fill: `primary` }}
      />
      <circle
        cx="11.9867"
        cy="33.8238"
        r="2.05882"
        transform="rotate(-45 11.9867 33.8238)"
        sx={{ fill: `primary` }}
      />
      <circle
        cx="33.8238"
        cy="11.9867"
        r="2.05882"
        transform="rotate(-45 33.8238 11.9867)"
        sx={{ fill: `primary` }}
      />
      <circle
        cx="11.9867"
        cy="11.9867"
        r="2.05882"
        transform="rotate(45 11.9867 11.9867)"
        sx={{ fill: `primary` }}
      />
      <circle
        cx="33.8239"
        cy="33.8238"
        r="2.05882"
        transform="rotate(45 33.8239 33.8238)"
        sx={{ fill: `primary` }}
      />
      <circle
        cx="8.66495"
        cy="28.8755"
        r="2.05882"
        transform="rotate(-22.7457 8.66495 28.8755)"
        sx={{ fill: `primary` }}
      />
      <circle
        cx="37.1455"
        cy="16.9351"
        r="2.05882"
        transform="rotate(-22.7457 37.1455 16.9351)"
        sx={{ fill: `primary` }}
      />
      <circle
        cx="16.935"
        cy="8.66492"
        r="2.05882"
        transform="rotate(67.2543 16.935 8.66492)"
        sx={{ fill: `primary` }}
      />
      <circle
        cx="28.8755"
        cy="37.1456"
        r="2.05882"
        transform="rotate(67.2543 28.8755 37.1456)"
        sx={{ fill: `primary` }}
      />
      <circle
        cx="17.0574"
        cy="37.1962"
        r="2.05882"
        transform="rotate(-67.7457 17.0574 37.1962)"
        sx={{ fill: `primary` }}
      />
      <circle
        cx="28.7531"
        cy="8.61427"
        r="2.05882"
        transform="rotate(-67.7457 28.7531 8.61427)"
        sx={{ fill: `primary` }}
      />
      <circle
        cx="8.61428"
        cy="17.0574"
        r="2.05882"
        transform="rotate(22.2543 8.61428 17.0574)"
        sx={{ fill: `primary` }}
      />
      <circle
        cx="37.1962"
        cy="28.7531"
        r="2.05882"
        transform="rotate(22.2543 37.1962 28.7531)"
        sx={{ fill: `primary` }}
      />
      <path
        d="M54.3311 26.001C54.4131 26.5928 54.5742 27.0352 54.8145 27.3281C55.2539 27.8613 56.0068 28.1279 57.0732 28.1279C57.7119 28.1279 58.2305 28.0576 58.6289 27.917C59.3848 27.6475 59.7627 27.1465 59.7627 26.4141C59.7627 25.9863 59.5752 25.6553 59.2002 25.4209C58.8252 25.1924 58.2363 24.9902 57.4336 24.8145L56.0625 24.5068C54.7148 24.2021 53.7832 23.8711 53.2676 23.5137C52.3945 22.916 51.958 21.9814 51.958 20.71C51.958 19.5498 52.3799 18.5859 53.2236 17.8184C54.0674 17.0508 55.3066 16.667 56.9414 16.667C58.3066 16.667 59.4697 17.0303 60.4307 17.7568C61.3975 18.4775 61.9043 19.5264 61.9512 20.9033H59.3496C59.3027 20.124 58.9629 19.5703 58.3301 19.2422C57.9082 19.0254 57.3838 18.917 56.7568 18.917C56.0596 18.917 55.5029 19.0576 55.0869 19.3389C54.6709 19.6201 54.4629 20.0127 54.4629 20.5166C54.4629 20.9795 54.668 21.3252 55.0781 21.5537C55.3418 21.7061 55.9043 21.8848 56.7656 22.0898L58.998 22.626C59.9766 22.8604 60.7148 23.1738 61.2129 23.5664C61.9863 24.1758 62.373 25.0576 62.373 26.2119C62.373 27.3955 61.9189 28.3799 61.0107 29.165C60.1084 29.9443 58.8311 30.334 57.1787 30.334C55.4912 30.334 54.1641 29.9502 53.1973 29.1826C52.2305 28.4092 51.7471 27.3486 51.7471 26.001H54.3311ZM75.59 17.0449V19.3389H71.7141V30H68.9895V19.3389H65.0959V17.0449H75.59ZM78.9809 17.0449H81.7318V25.0078C81.7318 25.8984 81.8373 26.5488 82.0482 26.959C82.3764 27.6855 83.0912 28.0488 84.1928 28.0488C85.2885 28.0488 86.0004 27.6855 86.3285 26.959C86.5395 26.5488 86.6449 25.8984 86.6449 25.0078V17.0449H89.3959V25.0078C89.3959 26.3848 89.182 27.457 88.7543 28.2246C87.9574 29.6309 86.4369 30.334 84.1928 30.334C81.9486 30.334 80.4252 29.6309 79.6225 28.2246C79.1947 27.457 78.9809 26.3848 78.9809 25.0078V17.0449ZM96.4166 19.2949V27.75H98.9127C100.19 27.75 101.081 27.1201 101.585 25.8604C101.86 25.1689 101.998 24.3457 101.998 23.3906C101.998 22.0723 101.79 21.0615 101.374 20.3584C100.963 19.6494 100.143 19.2949 98.9127 19.2949H96.4166ZM99.3697 17.0449C100.172 17.0566 100.84 17.1504 101.374 17.3262C102.282 17.625 103.017 18.1729 103.58 18.9697C104.031 19.6143 104.338 20.3115 104.503 21.0615C104.667 21.8115 104.749 22.5264 104.749 23.2061C104.749 24.9287 104.403 26.3877 103.712 27.583C102.774 29.1943 101.327 30 99.3697 30H93.7887V17.0449H99.3697ZM115.988 17.0449H119.055L114.722 25.1309V30H112.015V25.1309L107.533 17.0449H110.723L113.413 22.6875L115.988 17.0449Z"
        sx={{ fill: `primary` }}
      />
    </svg>
  )
}

export default Logo
